import { useFormik } from "formik";
import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { BASE_URL } from "../../../config";
import Loading from "../Loading";
import { httpReauest } from "../../../utils/httpRequest";

const CreateAdminForm = () => {
  const [loading, setloading] = useState();

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      username: Yup.string().required("الزامی است"),
      password: Yup.string().required("الزامی است"),
      name: Yup.string().required("الزامی است"),
      phone: Yup.string().required("الزامی است"),
    });
  };

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      name: "",
      phone: "",
      nationalCode: "",
      address: "",
      state: "",
      city: "",
      postalCode: "",
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      setloading(true);
      const user = JSON.parse(localStorage.getItem("user"));

      await httpReauest("POST", "/partner/create", values, {
        "x-access-token": user.token,
      })
        .then((dat) => {
          if (dat?.status == 201) {
            toast.success("همکار ساخته شد");
            setloading(false);
            formik.resetForm();
          }
        })
        .catch((err) => {
          setloading(false);
          toast.error(err.response?.data?.message);
        });
    },
  });

  return (
    <div>
      <h2 className="text-[20px] mb-8 font-bold p-3">فرم ایجاد همکار</h2>
      <form
        onSubmit={formik.handleSubmit}
        className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6"
      >
        <span className="relative">
          <input
            id="username"
            name="username"
            value={formik.values.username}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.username && formik.touched.username && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.username}
            </small>
          )}
          <p className="on-border font-bold">نام کاربری(انگلیسی)*</p>
        </span>
        <span className="relative">
          <input
            id="password"
            name="password"
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.password && formik.touched.password && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.password}
            </small>
          )}
          <p className="on-border font-bold">رمز عبور*</p>
        </span>
        <span className="relative">
          <input
            id="name"
            name="name"
            type="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.name && formik.touched.name && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.name}
            </small>
          )}
          <p className="on-border font-bold">اسم*</p>
        </span>
        <span className="relative">
          <input
            id="phone"
            name="phone"
            type="phone"
            value={formik.values.phone}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.phone && formik.touched.phone && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.phone}
            </small>
          )}
          <p className="on-border font-bold">شماره تلفن*</p>
        </span>

        <span className="relative">
          <input
            id="nationalCode"
            name="nationalCode"
            type="nationalCode"
            value={formik.values.nationalCode}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.nationalCode && formik.touched.nationalCode && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.nationalCode}
            </small>
          )}
          <p className="on-border font-bold">کدملی*</p>
        </span>

        <span className="relative">
          <input
            id="state"
            name="state"
            type="state"
            value={formik.values.state}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.state && formik.touched.state && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.state}
            </small>
          )}
          <p className="on-border font-bold">استان*</p>
        </span>

        <span className="relative">
          <input
            id="city"
            name="city"
            type="city"
            value={formik.values.city}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.city && formik.touched.city && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.city}
            </small>
          )}
          <p className="on-border font-bold">شهر*</p>
        </span>

        <span className="relative">
          <input
            id="postalCode"
            name="postalCode"
            type="postalCode"
            value={formik.values.postalCode}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.postalCode && formik.touched.postalCode && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.postalCode}
            </small>
          )}
          <p className="on-border font-bold">کد پستی*</p>
        </span>

        <span className="relative">
          <input
            id="address"
            name="address"
            type="address"
            value={formik.values.address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full form-brand h-[48px]"
          />
          {formik.errors.address && formik.touched.address && (
            <small style={{ color: "red", fontSize: "14px" }}>
              {formik.errors.address}
            </small>
          )}
          <p className="on-border font-bold">آدرس*</p>
        </span>

        <span className="col-span-full">
          {loading ? <Loading /> : <button className="btn-brand">ارسال</button>}
        </span>
      </form>
    </div>
  );
};

export default CreateAdminForm;
